import React from "react";
import AddAndUpdateSchool from "./Add&UpdateSchoolForm";

const AddSchool = () => {
  return <AddAndUpdateSchool />;
};

export default AddSchool;
